module.exports = __webpack_public_path__ + "img/hospitium-16.b63a0d94.jpg";